import '../sass/carousel.sass';

import { ScrollSnapArrows } from './scroll-snap-arrows';
import { loadLazyVideo } from './functions';

const animateSlideHover = (carouselSlide: HTMLElement, carouselGlobalHover: HTMLElement) => {
    const carouselHover = carouselSlide.querySelector(".carousel__hover") as HTMLElement|null;
    if (!carouselHover) return;
    // Gère le clic global sur l'aperçu
   setTimeout(() => {
       const mainBtn = carouselGlobalHover.querySelector<HTMLAnchorElement>('.carousel-hover__play');
       if (mainBtn?.href) {
           carouselGlobalHover.style.cursor = 'pointer';
           carouselGlobalHover.onclick = (e) => {
               const target = e.target as HTMLElement;
               if (!target.closest('button, a')) window.location.href = mainBtn.href;
           };
       }
   }, 0);

    carouselGlobalHover.innerHTML = carouselHover.innerHTML;

    const lazyVideos = carouselGlobalHover.querySelectorAll("video.lazy");
    lazyVideos.forEach(loadLazyVideo);

    carouselGlobalHover.querySelectorAll('.carousel-hover__video').forEach(video => {
        video.addEventListener('loadedmetadata', function () { this.currentTime = 4; });
    });
    // Règle métier : calcul de la largeur du hover
    // - Format 16:9 : pas d'agrandissement (hover = slide)
    // - Slides larges (>18% viewport) : agrandissement modéré (×1.3)
    // - Slides étroites (≤18% viewport) : agrandissement important (×1.7)
    // Objectif : adapter l'expansion selon l'espace disponible
    const slideRect = carouselSlide.getBoundingClientRect();
    const parent = carouselSlide.parentNode as HTMLElement;
    const parentRect = parent.getBoundingClientRect();
    const isAspect16_9 = carouselSlide.classList.contains('aspect-ratio-16-9');
    const viewportWidth = window.innerWidth;
    const slideWidthPercent = (slideRect.width / viewportWidth) * 100;

    const ratio = slideWidthPercent > 18 ? 1.3 : 1.7;
    // Min width du focus
    const minWidth = 330
    const hoverWidth = isAspect16_9 ? Math.max(slideRect.width, minWidth) : Math.max(slideRect.width * ratio, minWidth);
    const offsetX = (slideRect.width - hoverWidth) / 2;

    let left = window.scrollX + slideRect.left + offsetX;
    const minLeft = window.scrollX + parentRect.left;
    const maxLeft = window.scrollX + parentRect.right - hoverWidth;
    left = Math.max(minLeft, Math.min(maxLeft, left));

   carouselGlobalHover.style.cssText = `
       --carousel-hover-width: ${hoverWidth}px;
       min-height: ${slideRect.height}px;
       top: ${window.scrollY + slideRect.top}px;
       left: ${left}px;
   `;

    carouselGlobalHover.classList.add("active");
    carouselSlide.classList.add('carousel-active-slide')

    const carouselSoundButton = carouselGlobalHover.querySelector(".carousel-hover__sound");
    if (carouselSoundButton) {
        const carouselVideo = carouselGlobalHover.querySelector(".carousel-hover__video") as HTMLVideoElement|null;
        carouselSoundButton.addEventListener("click", (e) => {
            e.preventDefault();
            if (null !== carouselVideo) {
                carouselVideo.muted = !carouselVideo.muted;
            }
            const soundSvgs = [].slice.call(carouselSoundButton.querySelectorAll("img"));
            soundSvgs.forEach((soundSvg: SVGElement) => soundSvg.classList.toggle("active"));
        });
    }
}

const initAnimateSlideHover = (carouselSlide: HTMLElement, carouselGlobalHover: HTMLElement) => {
    const timer = setTimeout(() => animateSlideHover(carouselSlide, carouselGlobalHover),600);
    carouselSlide.onmouseout = function() {  clearTimeout(timer); }
};

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll('.js-remove-from-playback-history').forEach(function (element) {
        element.addEventListener('click', function (e) {
            e.preventDefault();

            const url = this.getAttribute('data-href');
            const slide = this.closest('.carousel__slide');

            ajaxRemoveFromPlaybackHistory(url, slide);
        });
    });

    const carousels = document.querySelectorAll('.carousel');
    carousels.forEach(carousel => {
        const manual = new ScrollSnapArrows(carousel.querySelector('.carousel__content'));
        manual.addArrow('left', carousel.querySelector('.carousel-arrow__left'));
        manual.addArrow('right', carousel.querySelector('.carousel-arrow__right'));
    });

    const carouselGlobalHover = document.querySelector(".carousel-global__hover") as HTMLElement|null;
    let hoverTimeout: number | null = null; 
    if (null !== carouselGlobalHover) {
        document.addEventListener("mouseover", async (e) => {
            const el = e.target as HTMLElement;
            if (el.closest(".carousel__slide") || el.closest(".search-item")) {
                if (hoverTimeout) {
                    clearTimeout(hoverTimeout);
                    hoverTimeout = null;
                }
                initAnimateSlideHover(el.closest(".carousel__slide") ?? el.closest(".search-item"), carouselGlobalHover);
            }
        });
        // const carouselSlides = [].slice.call(document.querySelectorAll(".carousel__slide"));
        // carouselSlides.forEach(function (carouselSlide: HTMLElement) {
        //     carouselSlide.addEventListener("mouseover", () => {
        //         if (hoverTimeout) {
        //             clearTimeout(hoverTimeout);
        //             hoverTimeout = null;
        //         }
        //         initAnimateSlideHover(carouselSlide, carouselGlobalHover);
        //     });
        //     // carouselSlide.addEventListener("mouseleave", (e) => {
        //     //     var video = carouselSlide.querySelector(".carousel-hover__video");
        //     //     if (video) {
        //     //         video.currentTime = 0;
        //     //     }
        //     // });
        // });
       carouselGlobalHover.addEventListener("mouseleave", () => {
           if (hoverTimeout) clearTimeout(hoverTimeout);
           document.querySelectorAll('.carousel-active-slide').forEach(el => el.classList.remove('carousel-active-slide'));
           // Coupe le son à la fermeture du hover
           const carouselVideo = carouselGlobalHover.querySelector(".carousel-hover__video") as HTMLVideoElement|null;
           if (carouselVideo) {
               carouselVideo.muted = true;
           } 
           carouselGlobalHover.classList.remove("active");
       });
    }
});

function ajaxRemoveFromPlaybackHistory(url: string, slide: HTMLElement) {
    fetch(url, {
        method: 'GET',
        headers: {
            'Accept': 'application/json'
        }
    })
        .then(function (response) {
            return response.json();
        })
        .then(function () {
            slide.remove();
        })
        .catch(function (error) {
            console.error('Error:', error);
        });
}
